module.exports = {
	INVENTORY_API_ADDRESS: process.env.INVENTORY_API_ADDRESS || 'http://localhost:3001',
};
